let service = {
    CATEGORY_ONE_TIME_SERVICE: 8,
    CATEGORY_FAVORITE: 6,

    category: '#service_category',
    duration: '#service_duration',
    autoRenewal: '#service_autoRenewal',
    childrenServices: '#service_childrenServices',
    allowedSlaveServices: '#service_allowedSlaveServices',
    slaveServicesCountRequired: '#service_slaveServicesCountRequired',

    ready: function () {
        $(() => {
            this.init();
            this.events();
        });
    },

    init: function () {
        this.categoryChange();
    },

    events: function () {
        this.categoryChangeEvent();
    },

    categoryChangeEvent: function () {
        $(this.category).on('change', () => {
            this.categoryChange();
        });
    },

    categoryChange: function () {
        const categoryId = $(this.category).val();
        const duration = $(this.duration);
        const autoRenewal = $(this.autoRenewal);
        const childrenServices = $(this.childrenServices);
        const allowedSlaveServices = $(this.allowedSlaveServices);
        const slaveServicesCountRequired = $(this.slaveServicesCountRequired);

        if (categoryId == this.CATEGORY_FAVORITE || categoryId == this.CATEGORY_ONE_TIME_SERVICE) {
            duration.prop('disabled', true);
            autoRenewal.prop('disabled', true);
            childrenServices.prop('disabled', true);
            allowedSlaveServices.prop('disabled', true);
            slaveServicesCountRequired.prop('disabled', true);
        } else {
            duration.prop('disabled', false);
            autoRenewal.prop('disabled', false);
            childrenServices.prop('disabled', false);
            allowedSlaveServices.prop('disabled', false);
            slaveServicesCountRequired.prop('disabled', false);
        }
    }
};

service.ready();
